import { Label, Separator, Stack } from "@fluentui/react";
import React from "react";
import InputMetaDataFactory from "../../src/taskpane/components/directoryComponents/InputMetadataFactory";
import { SharePointInputData } from "../../src/taskpane/interfaces/props/SharePointInputData";
import { ICustomFieldDefinition } from "../../src/taskpane/components/helpers/customFieldsHelper";
import { LanguageContext } from "../../utilities/LocalizationModule";

export interface ICustomFieldsSectionProps {
  definitions: ICustomFieldDefinition[];
  inputValues: SharePointInputData[];
  onChange: (index: number, value: any, hasError: boolean) => void;
  webUrl: string;
  sharepointListId: string;
  regionalSetting?: any;
}

/**
 * The template's custom placeholders as required inputs, in their own titled section below
 * the SharePoint metadata. Renders through InputMetaDataFactory with synthesized field xml;
 * datasourceFields stays undefined so the classifier can never reroute a custom field to a
 * datasource input, and sharepointService is never needed by the five supported input types.
 */
export const CustomFieldsSection = ({ definitions, inputValues, onChange, webUrl, sharepointListId, regionalSetting }: ICustomFieldsSectionProps) => {
  const languageStrings = React.useContext(LanguageContext);

  if (!definitions?.length || !inputValues?.length) return null;

  return (
    <Stack tokens={{ childrenGap: 8 }} style={{ marginTop: 12 }}>
      <Separator />
      <Label>{languageStrings.CustomFieldsSection}</Label>
      {inputValues.map(input => (
        <Stack.Item key={input.internalName}>
          <InputMetaDataFactory
            xml={input.xml}
            choices={undefined}
            webUrl={webUrl}
            sharepointService={undefined}
            handleInputChange={onChange}
            inputData={input}
            internalName={input.internalName}
            regionalSetting={regionalSetting}
            sharepointListId={sharepointListId}
            datasourceFields={undefined}
            containerDisplayNames={undefined}
          />
        </Stack.Item>
      ))}
    </Stack>
  );
};
